import React from 'react'
import './about.css'
import ME from '../../assets/me.png'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { VscFolderLibrary } from 'react-icons/vsc'
const About = () => {
  return (
    <section id='about'>
      <hr />  
      <p>&nbsp;</p>
      <h5>Get To Know About Me</h5>
      <h1>About Me</h1>
     
      <p>&nbsp;</p>
      <div className="container about__container">
        <div className="about__me">
          <img src={ME} className="about__me-image" alt="About_image" />
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className='about__icon' />
              <h4>Experience</h4>
              <small>1 Year of programming</small><br />
              <small>2+ Years of Designing</small>
            </article>
            <article className="about__card">
              <FiUsers className='about__icon' />
              <h4>Clients</h4>
              <small>15+ satisfied design clients</small>
            </article>
            <article className="about__card">
              <VscFolderLibrary className='about__icon' />
              <h4>Projects</h4>
              <small>50+ projects completed</small>
            </article>
          </div>

          <p>
            I’m an ambitious person, motivated to work in a dynamic and fast-growing environment
            with diverse range of activities. I stand challenged to work with minimal supervision and undertake any
            upcoming challenging tasks.
            <h6>&</h6>
            <h3><strong>Personal Skills</strong></h3>
            <h4>Adaptability • Interpersonal Skills • Team Player • Communication skills • Fast Learner • Critical Thinking • Leadership</h4>
            <h6>&</h6>
            <h3><strong>Hobbies</strong></h3>
            <li>&nbsp;&nbsp; • Playing football</li>
            <li>&nbsp;&nbsp; • Video Games </li>
            <li>&nbsp;&nbsp; • Animations </li>
          </p>

          {/* <a href="#contact" className='btn btn-primary'>Let's Talk</a> */}
        </div>
      </div>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <hr className='hr__tag'/>
    </section>
  )
}

export default About